<h2>{{ title }}</h2>
<div class="metric-value" dir="ltr">
  <ng-container *ngIf="metric !== null; else unavailable">{{ metric | number:(percentage ? '1.1-1' : '1.0-0'):'en-US' }}<span *ngIf="percentage">%</span></ng-container>
  <ng-template #unavailable>—</ng-template>
</div>
<p>{{ metric !== null ? description : 'اطلاعات در دسترس نیست' }}</p>
